import React from 'react';
import Link from 'next/link';

const floatingBadges = [
  { emoji: '🍍', label: 'Pineapple Hunter', delay: '0s', pos: 'top-24 left-8 lg:left-16' },
  { emoji: '🔮', label: 'Lavender Gooms', delay: '1.5s', pos: 'top-40 right-8 lg:right-20' },
  { emoji: '🕵🏾', label: 'Jamaican Inspector Man', delay: '0.8s', pos: 'bottom-32 left-12 lg:left-24' },
  { emoji: '🚙', label: 'Blueberry', delay: '2s', pos: 'bottom-48 right-6 lg:right-16' },
];

// Pre-computed random stars to avoid hydration mismatch
const stars = [
  { top: 4.2, left: 12.7, size: 1.5, opacity: 0.4 },
  { top: 8.1, left: 87.3, size: 1, opacity: 0.3 },
  { top: 13.5, left: 34.6, size: 2, opacity: 0.5 },
  { top: 6.8, left: 56.2, size: 1, opacity: 0.25 },
  { top: 19.4, left: 72.1, size: 1.5, opacity: 0.4 },
  { top: 2.3, left: 45.8, size: 1, opacity: 0.3 },
  { top: 25.7, left: 8.4, size: 2, opacity: 0.45 },
  { top: 31.2, left: 91.5, size: 1, opacity: 0.3 },
  { top: 17.9, left: 23.3, size: 1.5, opacity: 0.35 },
  { top: 38.6, left: 63.7, size: 1, opacity: 0.25 },
  { top: 44.1, left: 18.9, size: 2, opacity: 0.4 },
  { top: 11.3, left: 79.4, size: 1, opacity: 0.3 },
  { top: 52.8, left: 42.1, size: 1.5, opacity: 0.35 },
  { top: 7.6, left: 3.2, size: 1, opacity: 0.2 },
  { top: 61.4, left: 85.6, size: 2, opacity: 0.45 },
  { top: 29.3, left: 51.8, size: 1, opacity: 0.3 },
  { top: 68.7, left: 27.4, size: 1.5, opacity: 0.4 },
  { top: 15.2, left: 67.9, size: 1, opacity: 0.25 },
  { top: 75.1, left: 11.6, size: 2, opacity: 0.35 },
  { top: 22.8, left: 96.3, size: 1, opacity: 0.3 },
  { top: 82.4, left: 58.2, size: 1.5, opacity: 0.4 },
  { top: 47.6, left: 74.8, size: 1, opacity: 0.25 },
  { top: 89.3, left: 33.7, size: 2, opacity: 0.45 },
  { top: 35.9, left: 4.9, size: 1, opacity: 0.3 },
  { top: 93.7, left: 77.1, size: 1.5, opacity: 0.35 },
  { top: 57.2, left: 15.3, size: 1, opacity: 0.2 },
  { top: 3.8, left: 29.6, size: 2, opacity: 0.4 },
  { top: 71.5, left: 48.7, size: 1, opacity: 0.3 },
  { top: 86.1, left: 92.4, size: 1.5, opacity: 0.35 },
  { top: 42.3, left: 38.5, size: 1, opacity: 0.25 },
  { top: 9.7, left: 61.4, size: 2, opacity: 0.4 },
  { top: 64.8, left: 6.8, size: 1, opacity: 0.3 },
  { top: 78.9, left: 83.2, size: 1.5, opacity: 0.45 },
  { top: 20.6, left: 44.1, size: 1, opacity: 0.25 },
  { top: 55.4, left: 97.6, size: 2, opacity: 0.35 },
  { top: 33.7, left: 70.3, size: 1, opacity: 0.3 },
  { top: 96.2, left: 21.8, size: 1.5, opacity: 0.4 },
  { top: 48.9, left: 55.9, size: 1, opacity: 0.2 },
  { top: 16.4, left: 88.7, size: 2, opacity: 0.45 },
  { top: 73.3, left: 37.2, size: 1, opacity: 0.3 },
  { top: 91.8, left: 14.5, size: 1.5, opacity: 0.35 },
  { top: 27.1, left: 59.8, size: 1, opacity: 0.25 },
  { top: 59.6, left: 25.6, size: 2, opacity: 0.4 },
  { top: 5.4, left: 73.2, size: 1, opacity: 0.3 },
  { top: 84.7, left: 46.3, size: 1.5, opacity: 0.35 },
  { top: 39.8, left: 1.7, size: 1, opacity: 0.2 },
  { top: 67.2, left: 94.8, size: 2, opacity: 0.4 },
  { top: 12.9, left: 17.4, size: 1, opacity: 0.3 },
  { top: 79.5, left: 66.1, size: 1.5, opacity: 0.45 },
  { top: 50.3, left: 31.9, size: 1, opacity: 0.25 },
];

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-16" style={{ background: 'var(--background)' }}>
      {/* Random stars background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {stars?.map((star, i) => (
          <div
            key={`star-${i}`}
            className="absolute rounded-full bg-white"
            style={{
              top: `${star?.top}%`,
              left: `${star?.left}%`,
              width: `${star?.size}px`,
              height: `${star?.size}px`,
              opacity: star?.opacity,
            }}
          />
        ))}
      </div>
      {/* Background glow — yellow center only */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full opacity-10"
          style={{ background: 'radial-gradient(circle, #F5C518 0%, transparent 70%)' }} />
      </div>
      {/* Floating badges */}
      {floatingBadges?.map((badge) => (
        <div
          key={`hero-badge-${badge?.label}`}
          className={`absolute ${badge?.pos} hidden lg:flex items-center gap-2 card-glass rounded-full px-3 py-1.5 animate-float`}
          style={{ animationDelay: badge?.delay }}
        >
          <span className="text-lg">{badge?.emoji}</span>
          <span className="text-xs font-semibold text-foreground">{badge?.label}</span>
        </div>
      ))}
      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
        {/* Eyebrow */}
        <div className="inline-flex items-center gap-2 bg-primary/10 border border-primary/30 rounded-full px-4 py-1.5 mb-6">
          <span className="w-2 h-2 bg-primary rounded-full animate-pulse" />
          <span className="text-xs font-semibold text-primary tracking-wide uppercase">Season 1 Now Open — Psych Universe</span>
        </div>

        <h1 className="text-hero-xl font-extrabold text-foreground mb-6 leading-tight">
          Compete in your
          <span className="gradient-text-primary block">Favorite Fan Universe</span>
        </h1>

        <p className="text-lg text-muted-foreground max-w-2xl mx-auto mb-8 leading-relaxed">
          FanFinite turns your obsession into a competition. Pick your favorite TV show or Movie and play themed mini-games,
          earn XP and badges, and prove you&apos;re the Ultimate Fan!
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <Link
            href="/sign-up-login-screen"
            className="w-full sm:w-auto px-8 py-4 gradient-secondary text-white text-base font-bold rounded-2xl hover:opacity-90 transition-all duration-150 active:scale-95 card-glow-yellow"
          >
            🍍 Join the Case Files
          </Link>
          <a
            href="#psych-world"
            className="w-full sm:w-auto px-8 py-4 bg-transparent border border-border text-foreground text-base font-semibold rounded-2xl hover:border-primary/50 hover:bg-primary/5 transition-all duration-150"
          >
            Explore Psych World →
          </a>
        </div>

        {/* Stats row */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-8 text-center">
          {[
            { value: '12K+', label: 'Fans Competing', icon: '👥' },
            { value: '847', label: 'Questions in Psych World', icon: '🗂️' },
            { value: '24', label: 'Unique Badges', icon: '🏅' },
            { value: '6', label: 'Rank Tiers', icon: '🏆' },
          ]?.map((stat) => (
            <div key={`stat-${stat?.label}`} className="flex flex-col items-center">
              <span className="text-2xl mb-1">{stat?.icon}</span>
              <span className="text-2xl font-extrabold text-foreground font-mono-data">{stat?.value}</span>
              <span className="text-xs text-muted-foreground font-medium mt-0.5">{stat?.label}</span>
            </div>
          ))}
        </div>
      </div>
      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 pointer-events-none"
        style={{ background: 'linear-gradient(to bottom, transparent, var(--background))' }} />
    </section>
  );
}